export function calcExchangeRevenue(netRevenueUSD: number, blackMarketRate: number): number {
  return netRevenueUSD * blackMarketRate;
}

export function calcBankCost(grossVolumeUSD: number, bankRate: number): number {
  return grossVolumeUSD * bankRate;
}

export function calcBankCostSplit(
  debitGrossUSD: number,
  creditGrossUSD: number,
  debitRate: number,
  creditRate: number,
): number {
  return (debitGrossUSD * debitRate) + (creditGrossUSD * creditRate);
}

export function calcExchangeProfit(netRevenueUSD: number, blackMarketRate: number, grossVolumeUSD: number, bankRate: number): number {
  return (netRevenueUSD * blackMarketRate) - (grossVolumeUSD * bankRate);
}

export function calcExchangeProfitSplit(
  netRevenueUSD: number,
  blackMarketRate: number,
  debitGrossUSD: number,
  creditGrossUSD: number,
  debitRate: number,
  creditRate: number,
): number {
  return (netRevenueUSD * blackMarketRate) - calcBankCostSplit(debitGrossUSD, creditGrossUSD, debitRate, creditRate);
}

export function calcNetProfit(exchangeProfitMVR: number, totalExpensesMVR: number): number {
  return exchangeProfitMVR - totalExpensesMVR;
}
